<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Crear Remision</p>
              <div class="ms-auto d-flex gap-2">
                <a v-if="false" @click="printRemission(form.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                  style="margin-left: 15px; display: flex; align-items: center;" data-toggle="tooltip" data-original-title="Imprimir remisión">
                  <i class="fas fa-print" style="font-size: 1.2rem;"></i>
                </a>
                <argon-button v-if="(user.role != '1' && form.status === 0) || user.role === '1'" color="success"
                  size="sm" @click="save">Guardar</argon-button>
                <argon-button v-if="form.status == 0 && form.id > 0" color="success" size="sm" @click="confirm">Formalizar</argon-button>
                <argon-button v-if="parseInt(form.status) == 1 && form.type !== 'return'" color="danger"
                  size="sm" @click="devolucion">Devolución</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="position: relative;">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2 align-items-stretch">
                  <div class="flex-grow-1" style="min-width: 0;">
                    <select ref="clientSelect" class="form-control select2 w-100" style="width: 100%">
                    </select>
                  </div>
                  <argon-button color="success" size="sm" @click="openClientModal">
                    <i class="fa fa-user-plus"></i> 
                  </argon-button>
                </div>
              </div>

              <div class="col-md-6">
                <label for="document-type" class="form-control-label">Tipo de Documento</label>
                <select id="documentType" class="form-control" v-model="form.document_type" :disabled="form.client_id > 0">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Número documento</label>
                <argon-input type="text" v-model="form.document" autocomplete="off" :disabled="form.client_id > 0" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" autocomplete="off" :disabled="form.client_id > 0" />
              </div>


              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Telefono</label>
                <argon-input type="text" v-model="form.phone" :disabled="form.client_id > 0" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <argon-input type="text" v-model="form.email" :disabled="form.client_id > 0" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-select-input" class="form-control-label">Estado</label>
                <input type="text" class="form-control" :value="estadoLabel" disabled />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" />
              </div>


            </div>
          </div>
        </div>
      </div>

      <!-- ===== SIDEBAR: Resumen financiero y Evidencias de pago ===== -->
      <div class="col-md-4" v-if="form.id != 0">
        <!-- Card: Resumen financiero -->
        <div class="card mb-2">
          <div class="card-header pb-0">
            <p class="text-uppercase mb-0">Resumen financiero</p>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-control-label text-sm">Método de pago</label>
              <input type="text" class="form-control form-control-sm" :value="form.payment_method || '—'" disabled />
            </div>

            <div class="d-flex justify-content-between text-sm mb-1">
              <span class="text-muted">Subtotal</span>
              <span class="font-weight-bold">{{ formatCOP(remissionTotal) }}</span>
            </div>

            <div class="d-flex justify-content-between text-sm mb-1" v-if="form.discount_amount > 0">
              <span class="text-danger">Descuento</span>
              <span class="text-danger">−{{ formatCOP(form.discount_amount) }}</span>
            </div>

            <div class="d-flex justify-content-between text-sm mb-1" v-if="form.flete > 0">
              <span class="text-success">Flete</span>
              <span class="text-success">+{{ formatCOP(form.flete) }}</span>
            </div>

            <div class="d-flex justify-content-between text-sm mb-1" v-if="form.gift_value > 0">
              <span class="text-success">Obsequio</span>
              <span class="text-success">+{{ formatCOP(form.gift_value) }}</span>
            </div>

            <hr class="my-2" />

            <div class="d-flex justify-content-between mb-1">
              <span class="font-weight-bold">Total</span>
              <span class="font-weight-bold text-primary">{{ formatCOP(form.grand_total || remissionTotal) }}</span>
            </div>

            <div class="d-flex justify-content-between text-sm mb-1" v-if="form.amount_paid > 0">
              <span class="text-muted">Valor pagado</span>
              <span class="text-success font-weight-bold">{{ formatCOP(form.amount_paid) }}</span>
            </div>

            <div class="d-flex justify-content-between text-sm" v-if="form.amount_paid > 0">
              <span class="text-muted">Saldo</span>
              <span :class="paymentBalance >= 0 ? 'text-danger' : 'text-success'" class="font-weight-bold">
                {{ formatCOP((form.grand_total || remissionTotal) - form.amount_paid) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Card: Evidencias de pago -->
        <div class="card">
          <div class="card-header pb-0">
            <p class="text-uppercase mb-0">Evidencias de pago</p>
          </div>
          <div class="card-body">
            <!-- Subida de archivos -->
            <label class="form-control-label text-sm">Subir evidencia (Imagen o PDF)</label>
            <input
              class="form-control form-control-sm"
              type="file"
              id="fileEvidenciaRemission"
              accept="image/*,.pdf"
              @change="saveEvidencia"
            />

            <!-- Lista de documentos -->
            <div v-if="documentos.length > 0" class="mt-3">
              <div class="evidence-thumbnails">
                <div
                  v-for="documento in documentos"
                  :key="documento.id"
                  class="evidence-thumb-wrapper"
                >
                  <div
                    v-if="isImage(documento.file_path)"
                    class="evidence-thumb"
                    @click="viewDocument(documento.file_path)"
                  >
                    <img :src="apiUrl + documento.file_path" alt="Evidencia" class="evidence-thumb-img">
                  </div>
                  <div
                    v-else
                    class="evidence-thumb evidence-thumb-file"
                    @click="viewDocument(documento.file_path)"
                  >
                    <i :class="getFileIcon(documento.file_path)" class="fa-2x"></i>
                    <span class="evidence-thumb-name">{{ documento.file_name }}</span>
                  </div>
                  <button
                    class="evidence-thumb-delete"
                    @click="deleteMedia(documento.id)"
                    title="Eliminar"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <p v-else-if="paymentEvidences.length === 0" class="text-center text-muted mt-2 text-sm">No hay evidencias cargadas.</p>

            <!-- Evidencias de pagos (subidas desde POS) -->
            <div v-if="paymentEvidences.length > 0" class="mt-3">
              <hr class="my-2">
              <p class="text-uppercase text-xs text-secondary mb-2">Evidencias de pagos</p>
              <div class="evidence-thumbnails">
                <div
                  v-for="pe in paymentEvidences"
                  :key="pe.id"
                  class="evidence-thumb-wrapper"
                >
                  <div
                    class="evidence-thumb"
                    @click="viewDocument(pe.evidence_path)"
                  >
                    <img :src="apiUrl + pe.evidence_path" alt="Evidencia de pago" class="evidence-thumb-img">
                  </div>
                  <div class="evidence-thumb-info">
                    <span class="evidence-thumb-method">{{ pe.payment_method }}</span>
                    <span class="evidence-thumb-amount">{{ formatCOP(pe.amount) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button v-if="user.role === '1' || user.role === '2'" variant="outline" color="secondary"
                  size="sm" type="button" @click="copyDetailsForExcel" title="Copiar ítems para Excel (orden plantilla contable)">
                  <i class="fas fa-copy" aria-hidden="true"></i>
                </argon-button>
                <argon-button v-if="false" color="success" size="sm"
                  @click="addDetail">Agregar producto</argon-button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                        Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        IVA (%)</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Total</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="false">
                        Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="value in data.data" :key="value.id">
                      <td>
                        <div class="d-flex px-2 py-1 align-items-center gap-2">
                          <img
                            v-if="value.inventory?.image_url"
                            :src="value.inventory.image_url"
                            :alt="value.inventory.name"
                            style="width:36px;height:36px;object-fit:cover;border-radius:6px;flex-shrink:0;"
                          />
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ value.inventory?.name
                                ?? value.production_model?.model?.name
                                ?? value.model?.name
                                ?? 'Sin nombre' }}
                            </h6>
                            <span class="text-xs text-secondary">
                              {{ value.inventory?.ref
                                ? 'Ref: ' + value.inventory.ref
                                : (value.production_model?.production?.name ?? value.produccion?.name ?? '') }}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ value.quantity }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.iva ?? 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                        </span>
                      </td>
                      <td class="align-middle text-center" v-if="false">
                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                           data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>
                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== SECCIÓN PAGOS ===== -->
    <div class="row mt-3" v-if="form.id != 0">
      <div class="col-md-10">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0">Pagos recibidos</p>
              <div class="ms-auto d-flex gap-2 align-items-center">
                <span class="text-sm text-muted me-2">
                  Saldo: <strong :class="paymentBalance >= 0 ? 'text-success' : 'text-danger'">
                    {{ formatCOP(paymentBalance) }}
                  </strong>
                </span>
                <argon-button color="success" size="sm" @click="openPaymentModal">
                  <i class="fas fa-plus me-1"></i> Agregar pago
                </argon-button>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-3">Fecha</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Método</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Referencia</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Valor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Registrado por</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="payments.length === 0">
                    <td colspan="6" class="text-center text-muted py-3 text-sm">Sin pagos registrados</td>
                  </tr>
                  <tr v-for="p in payments" :key="p.id">
                    <td class="ps-3">
                      <span class="text-xs text-secondary font-weight-bold">{{ p.payment_date ?? '—' }}</span>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-sm bg-gradient-info">{{ p.payment_method }}</span>
                    </td>
                    <td class="text-center">
                      <span class="text-xs text-secondary">{{ p.reference ?? '—' }}</span>
                    </td>
                    <td class="text-center">
                      <span class="text-xs font-weight-bold text-success">{{ formatCOP(p.amount) }}</span>
                    </td>
                    <td class="text-center">
                      <span class="text-xs text-secondary">{{ p.user?.name ?? '—' }}</span>
                    </td>
                    <td class="text-center">
                      <a @click="deletePayment(p.id)" class="text-danger font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" title="Eliminar pago">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="payments.length > 0">
                    <td colspan="3" class="text-end pe-3 py-2">
                      <strong class="text-xs text-uppercase text-secondary">Total pagado</strong>
                    </td>
                    <td class="text-center py-2">
                      <strong class="text-sm text-success">{{ formatCOP(totalPaid) }}</strong>
                    </td>
                    <td colspan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Pago -->
    <div class="modal fade" id="ModalPayment" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Registrar pago</h5>
            <button type="button" class="btn-close" @click="closePaymentModal"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Método de pago *</label>
              <select class="form-select" v-model="paymentForm.payment_method">
                <option value="EFECTIVO">EFECTIVO</option>
                <option value="TRANSFERENCIA">TRANSFERENCIA</option>
                <option value="TARJETA">TARJETA</option>
                <option value="DATAFONO">DATAFONO</option>
                <option value="NEQUI">NEQUI</option>
                <option value="BANCOLOMBIA AHORROS">BANCOLOMBIA AHORROS</option>
                <option value="BANCOLOMBIA SAS">BANCOLOMBIA SAS</option>
                <option value="DAVIPLATA">DAVIPLATA</option>
                <option value="CHEQUE">CHEQUE</option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Valor *</label>
              <input type="number" class="form-control" v-model.number="paymentForm.amount" min="0" step="1" />
            </div>
            <div class="mb-3">
              <label class="form-label">Referencia</label>
              <input type="text" class="form-control" v-model="paymentForm.reference" placeholder="Nro. transferencia, cheque..." />
            </div>
            <div class="mb-3">
              <label class="form-label">Fecha</label>
              <input type="date" class="form-control" v-model="paymentForm.payment_date" />
            </div>
            <div class="mb-3">
              <label class="form-label">Notas</label>
              <textarea class="form-control" v-model="paymentForm.notes" rows="2"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePaymentModal">Cerrar</button>
            <button type="button" class="btn btn-success" @click="savePayment" :disabled="savingPayment">
              {{ savingPayment ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Agregar Cliente -->
    <div class="modal fade" id="ModalClient" tabindex="-1" aria-labelledby="clientModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="clientModalLabel">Agregar Cliente</h5>
            <button type="button" class="btn-close" @click="closeClientModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="client-name" class="form-label">Nombre</label>
                <input type="text" v-model="newClient.name" id="client-name" class="form-control"
                  placeholder="Ingrese el nombre del cliente" required>
              </div>
              <div class="mb-3">
                <label for="client-document-type" class="form-label">Tipo de Documento</label>
                <select id="client-document-type" class="form-select" v-model="newClient.document_type">
                  <option value="" disabled>Seleccione un tipo de documento</option>
                  <option value="CC">Cédula de Ciudadanía (CC)</option>
                  <option value="CE">Cédula de Extranjería (CE)</option>
                  <option value="TI">Tarjeta de Identidad (TI)</option>
                  <option value="RC">Registro Civil (RC)</option>
                  <option value="PA">Pasaporte (PA)</option>
                  <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                  <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="client-document" class="form-label">Número de Documento</label>
                <input type="text" v-model="newClient.document" id="client-document" class="form-control"
                  placeholder="Ingrese el número de documento" required>
              </div>
              <div class="mb-3">
                <label for="client-address" class="form-label">Dirección</label>
                <input type="text" v-model="newClient.address" id="client-address" class="form-control"
                  placeholder="Ingrese la dirección">
              </div>
              <div class="mb-3">
                <label for="client-phone" class="form-label">Teléfono</label>
                <input type="text" v-model="newClient.phone" id="client-phone" class="form-control"
                  placeholder="Ingrese el teléfono" required>
              </div>
              <div class="mb-3">
                <label for="client-email" class="form-label">Email</label>
                <input type="email" v-model="newClient.email" id="client-email" class="form-control"
                  placeholder="Ingrese el email" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeClientModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="saveClient">Guardar Cliente</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de remision -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <!-- Buscador -->
            <div class="mb-3">
              <input
                type="text"
                v-model="productSearch"
                class="form-control"
                placeholder="Buscar producto..."
              />
            </div>

            <!-- Grid de productos -->
            <div v-if="loadingProducts" class="text-center py-4">
              <i class="fas fa-spinner fa-spin fa-2x text-success"></i>
            </div>
            <div v-else class="rem-product-grid">
              <button
                v-for="prod in filteredProducts"
                :key="prod.id"
                type="button"
                class="rem-product-card"
                @click="onProductClick(prod)"
              >
                <div class="rem-product-image mb-2 text-center">
                  <img
                    v-if="prod.image_url"
                    :src="prod.image_url"
                    :alt="prod.name"
                    style="width: 100%; max-height: 80px; object-fit: cover; border-radius: 6px;"
                    loading="lazy"
                  />
                  <i v-else class="fas fa-box-open text-secondary fa-2x"></i>
                </div>
                <div class="rem-product-info">
                  <h6 class="mb-0 text-sm">{{ prod.name || 'Sin nombre' }}</h6>
                  <p class="mb-0 text-xs text-secondary">Ref: {{ prod.ref || '—' }}</p>
                  <p class="mb-0 text-xs" :class="(prod.quantity > 0 || !prod.manage_stock) ? 'text-success' : 'text-danger'">
                    Stock: {{ prod.manage_stock ? (prod.quantity || 0) : 'N/A' }}
                  </p>
                  <span class="badge badge-sm bg-gradient-success">{{ formatCOP(prod.sale_price) }}</span>
                  <span v-if="prod.has_variants" class="badge badge-sm bg-gradient-info ms-1">Variantes</span>
                </div>
              </button>
            </div>
            <div v-if="!loadingProducts && filteredProducts.length === 0" class="text-center text-muted py-3">
              No hay productos disponibles
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal seleccionar variante (estilo POS) -->
    <div v-if="showVariantModal" class="rem-variant-overlay" @click.self="cancelVariantModal">
      <div class="rem-variant-box card shadow">
        <div class="card-body">
          <h6 class="mb-1">Seleccionar variante</h6>
          <p v-if="pendingProduct" class="text-sm text-muted mb-3">
            <strong>{{ pendingProduct.name }}</strong>
          </p>
          <div class="rem-variant-list">
            <button
              v-for="v in pendingProduct.variants"
              :key="v.id"
              type="button"
              class="rem-variant-btn"
              :class="{ 'rem-variant-btn--selected': selectedVariantId === v.id }"
              @click="selectedVariantId = v.id"
            >
              <span class="rem-variant-title">{{ v.title }}</span>
              <span class="rem-variant-meta">
                <span :class="v.inventory_quantity > 0 ? 'text-success' : 'text-danger'">
                  Stock: {{ v.inventory_quantity }}
                </span>
                &nbsp;·&nbsp;
                <strong>{{ formatCOP(v.price) }}</strong>
              </span>
            </button>
          </div>
          <div class="d-flex gap-2 justify-content-end mt-3">
            <button type="button" class="btn btn-secondary btn-sm" @click="cancelVariantModal">Cancelar</button>
            <button type="button" class="btn btn-success btn-sm" :disabled="!selectedVariantId" @click="confirmVariant">Agregar a lista de detalles</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import remissionPaymentsService from '../../../services/remissionPayments.service';
import posService from '../../../services/pos.service';


const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        name: '',
        client_id: 0,
        document_type:'',
        document:'',
        address:'',
        phone: '',
        email: '',
        observation: '',
        status: 0,
        type: 'production',
        payment_method: '',
        discount_amount: 0,
        flete: 0,
        gift_value: 0,
        amount_paid: 0,
        subtotal: 0,
        grand_total: 0,
      },
      data: {},
      modal: {
        id: 0,
        remission_id: 0,
        model_id: 0,
        inventory_id: 0,
        variant_id: null,
        quantity: 0,
        price: 0,
        iva: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      clientModal: null,
      payments: [],
      paymentModal: null,
      savingPayment: false,
      documentos: [],
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      productSearch: '',
      loadingProducts: false,
      showVariantModal: false,
      pendingProduct: null,
      selectedVariantId: null,
      paymentForm: {
        payment_method: 'EFECTIVO',
        amount: 0,
        reference: '',
        notes: '',
        payment_date: new Date().toISOString().slice(0, 10),
      },
      newClient: {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4', // Cliente
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonTextarea },
  computed: {
    estadoLabel() {
      if (this.form.type === 'return') return 'Devolución';
      if (parseInt(this.form.status) === 1) return 'Formalizada';
      return 'Pendiente';
    },
    formattedPrice: {
      get() {
        return this.modal.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.price = parseInt(value.replace(/\./g, "") || 0);
        this.updateModalLineTotal();
      },
    },
    totalPrice: {
      get() {
        return this.modal.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.modal.total = Math.floor(value.replace(/\./g, "") || 0);
        const quantity = parseFloat(this.modal.quantity) || 0;
        const ivaRate = (parseFloat(this.modal.iva) || 0) / 100;
        const divisor = quantity > 0 ? quantity * (1 + ivaRate) : 0;
        this.modal.price = divisor > 0 ? Math.floor(this.modal.total / divisor) : 0;
      },
    },
    totalPaid() {
      return this.payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
    },
    paymentEvidences() {
      return this.payments.filter((p) => p.evidence_path);
    },
    remissionTotal() {
      if (this.data?.data) {
        return this.data.data.reduce((s, d) => s + parseFloat(d.total || 0), 0);
      }
      return 0;
    },
    paymentBalance() {
      const total = this.form.grand_total || this.remissionTotal;
      return total - this.totalPaid;
    },
    filteredProducts() {
      const all = (this.models?.data) ? this.models.data : [];
      if (!this.productSearch) return all;
      const q = this.productSearch.toLowerCase();
      return all.filter((prod) => {
        const name = (prod.name || '').toLowerCase();
        const ref = (prod.ref || '').toLowerCase();
        const barcode = (prod.barcode || '').toLowerCase();
        return name.includes(q) || ref.includes(q) || barcode.includes(q);
      });
    },
  },
  watch: {
    'modal.quantity'() {
      this.updateModalLineTotal();
    },
  },
  methods: {
    updateModalLineTotal() {
      const price = parseFloat(this.modal.price) || 0;
      const quantity = parseFloat(this.modal.quantity) || 0;
      const ivaRate = (parseFloat(this.modal.iva) || 0) / 100;
      this.modal.total = Math.floor(price * quantity * (1 + ivaRate));
    },

    /** Valores numéricos con formato es-CO (como en plantilla Excel de la imagen). */
    formatExcelCurrency(value) {
      const n = parseFloat(value) || 0;
      return n.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    escapeExcelCell(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },

    /**
     * Una fila TSV en el orden de columnas de la plantilla: Item, Producto, Nombre… Vencimiento.
     */
    buildRemissionDetailExportRow(value, itemIndex) {
      const pm = value.production_model || {};
      const model = pm.model || value.model || {};
      const size = pm.size || {};
      const color = size.color || {};
      const qty = parseFloat(value.quantity) || 0;
      const price = parseFloat(value.price) || 0;
      const ivaPct = parseFloat(value.iva) || 0;
      const totalStored = parseFloat(value.total) || 0;
      const stock = pm.stock != null ? parseFloat(pm.stock) : 0;
      const base = qty * price;
      let valorIVA = 0;
      if (ivaPct > 0) {
        valorIVA = Math.max(0, totalStored - base);
      }

      const productoRef = model.ref ?? '';
      const nombreProducto = model.name ?? '';
      const talla = size.size ?? '';
      const colorCode = color.ref ?? color.name ?? '';

      const cells = [
        String(itemIndex + 1),
        this.escapeExcelCell(productoRef),
        this.escapeExcelCell(nombreProducto),
        this.escapeExcelCell(talla),
        this.escapeExcelCell(colorCode),
        this.formatExcelCurrency(stock),
        `${qty.toFixed(2)}`,
        `PAR`,
        this.formatExcelCurrency(price),
        ivaPct > 0 ? String(Math.round(ivaPct)) : '',
        '',
        ivaPct > 0 ? `${ivaPct.toFixed(2)} %` : '',
        this.formatExcelCurrency(valorIVA),
        this.formatExcelCurrency(0),
        this.formatExcelCurrency(base),
        '',
        '',
      ];

      return cells.join('\t');
    },

    async copyDetailsForExcel() {
      const rows = this.data?.data;
      if (!Array.isArray(rows) || rows.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin ítems',
          text: 'No hay líneas en esta remisión para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const tsv = rows
        .map((row, idx) => this.buildRemissionDetailExportRow(row, idx))
        .join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        await Swal.fire({
          icon: 'success',
          title: 'Copiado',
          text: 'Datos listos para pegar en Excel (Ctrl+V).',
          timer: 2200,
          showConfirmButton: false,
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles o no hay permisos HTTPS.',
          confirmButtonText: 'Aceptar',
        });
      }
    },

    mergeSeedClientsIntoList(seedRows) {
      const list = seedRows.filter(Boolean);
      for (const row of list) {
        const id = Number(row.id ?? row.user_id ?? 0);
        if (!id) {
          continue;
        }
        if (this.clients.some((c) => Number(c.id) === id)) {
          continue;
        }
        this.clients.push({
          id,
          name: row.name || '',
          email: row.email || '',
          phone: row.phone || '',
          address: row.address || '',
          document: row.document || '',
          document_type: row.document_type || '',
          role: row.role != null ? row.role : '4',
        });
      }
    },

    /**
     * Igual espíritu que `/purchases/create` (proveedor): armar opciones en Select2 y luego fijar valor.
     * Los usuarios de `seedClients` se fusionan **antes** de inicializar Select2 (si se añaden después,
     * Select2 no los refleja bien).
     *
     * @param {{ forceRebuild?: boolean, seedClients?: object[] }} opts
     */
    async getClients(opts = {}) {
      const forceRebuild = opts.forceRebuild === true;
      const seedClients = Array.isArray(opts.seedClients) ? opts.seedClients : [];

      try {
        const response = await this.$store.dispatch('users/getAll');
        let users = [];

        if (Array.isArray(response)) {
          users = response;
        } else if (response && response.data) {
          if (Array.isArray(response.data)) {
            users = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            users = response.data.data;
          }
        }

        this.clients = users.filter(
          (user) => user.role == '4' || user.role === 4,
        );

        this.mergeSeedClientsIntoList(seedClients);

        await new Promise((resolve) => {
          this.$nextTick(() => {
            try {
              const select = $(this.$refs.clientSelect);
              if (!select.length) {
                return;
              }

              if (select.hasClass('select2-hidden-accessible')) {
                if (!forceRebuild) {
                  if (this.form.client_id > 0) {
                    this.refreshClientSelect2Value(this.form.client_id);
                  }
                  return;
                }
                select.select2('destroy');
              }

              select.empty();
              /* Sin disabled+selected por defecto: Select2 suele aplicar mejor .val(...) al editar */
              select.append('<option value=""></option>');

              this.clients.forEach((client) => {
                const displayText = `${client.name} - ${client.email || client.phone || ''}`;
                select.append(new Option(displayText, String(client.id), false, false));
              });

              select
                .select2({
                  placeholder: 'Seleccione un cliente',
                  allowClear: true,
                  width: '100%',
                })
                .off('change.select2-remission')
                .on('change.select2-remission', () => {
                  const selectedId = select.val();
                  if (selectedId) {
                    const selectedClient = this.clients.find(
                      (c) => String(c.id) === String(selectedId),
                    );
                    if (selectedClient) {
                      this.form.client_id = Number(selectedClient.id);
                      this.form.name = selectedClient.name;
                      this.form.email = selectedClient.email || '';
                      this.form.phone = selectedClient.phone || '';
                      this.form.address = selectedClient.address || '';
                      this.form.document = selectedClient.document || '';
                      this.form.document_type = selectedClient.document_type || '';
                    } else {
                      this.form.client_id = Number(selectedId) || 0;
                    }
                  } else {
                    this.form.client_id = 0;
                    this.form.name = '';
                    this.form.email = '';
                    this.form.phone = '';
                    this.form.address = '';
                    this.form.document = '';
                    this.form.document_type = '';
                  }
                  this.syncClientSelect2Display();
                });

              if (this.form.client_id > 0) {
                this.refreshClientSelect2Value(this.form.client_id);
              }
            } finally {
              resolve();
            }
          });
        });
      } catch (error) {
        console.error('Error al obtener clientes:', error);
      }
    },

    /** Si `user_id` viene vacío en el listado, infiere cliente ya cargado en `this.clients`. */
    inferClientIdFromRemissionRow(parsed) {
      if (Number(this.form.client_id) > 0) {
        return;
      }

      const direct =
        Number(parsed?.user_id ?? parsed?.client_id ?? parsed?.user?.id ?? 0) || 0;
      if (direct) {
        this.form.client_id = direct;
        return;
      }

      const emailNorm = String(
        parsed?.email || this.form.email || '',
      )
        .trim()
        .toLowerCase();
      if (emailNorm) {
        const byEmail = this.clients.find(
          (c) => String(c.email || '').trim().toLowerCase() === emailNorm,
        );
        if (byEmail?.id != null) {
          this.form.client_id = Number(byEmail.id);
          return;
        }
      }

      const doc = String(parsed?.document || this.form.document || '').trim();
      const docType = String(
        parsed?.document_type || this.form.document_type || '',
      )
        .trim()
        .toUpperCase();
      if (doc) {
        const byDoc = this.clients.find((c) => {
          const sameDoc =
            String(c.document || '').trim() === doc &&
            String(c.document_type || '').trim().toUpperCase() === docType;
          return (
            sameDoc ||
            (!docType && String(c.document || '').trim() === doc)
          );
        });
        if (byDoc?.id != null) {
          this.form.client_id = Number(byDoc.id);
        }
      }
    },

    /**
     * Select2 en flex (p. ej. 4.x RC) a veces deja `.select2-selection__rendered` sin texto aunque
     * el `<select>` tiene `value`; forzamos el texto desde la opción seleccionada.
     */
    syncClientSelect2Display() {
      this.$nextTick(() => {
        const select = $(this.$refs.clientSelect);
        if (!select.length || !select.hasClass('select2-hidden-accessible')) {
          return;
        }
        const v = select.val();
        if (v == null || v === '') {
          return;
        }
        const vStr = String(v);
        let label = '';
        select.find('option').each(function () {
          if (String(this.value) === vStr) {
            label = (this.textContent || '').trim();
            return false;
          }
        });
        if (!label) {
          label = `#${vStr}`;
        }
        const container = select.next('.select2-container');
        if (!container.length) return;
        container.css({ width: '100%', maxWidth: '100%' });
        container.find('.select2-selection').css({ width: '100%' });
        const rendered = container.find('.select2-selection__rendered');
        if (!rendered.length) return;
        rendered.text(label);
        rendered.attr('title', label);
      });
    },

    /**
     * Asegura opción Select2 si falta el ID en la lista actual y fuerza valor + etiqueta visible.
     */
    refreshClientSelect2Value(cid) {
      const id = Number(cid) || 0;
      const select = $(this.$refs.clientSelect);
      if (!this.$refs.clientSelect || id <= 0 || !select.length) {
        return;
      }

      const idStr = String(id);
      if (!select.find(`option[value="${idStr}"]`).length && !select.find(`option[value="${id}"]`).length) {
        const label =
          `${this.form.name || 'Cliente'} - ${this.form.email || this.form.phone || idStr}`;
        select.append(new Option(label, idStr, false, false));
        if (
          !this.clients.some((c) => Number(c.id) === id)
        ) {
          this.clients.push({
            id,
            name: this.form.name,
            email: this.form.email || '',
            phone: this.form.phone || '',
            address: this.form.address || '',
            document: this.form.document || '',
            document_type: this.form.document_type || '',
            role: '4',
          });
        }
      }

      select.val(idStr).trigger('change');
      this.syncClientSelect2Display();
    },

    applyRemissionToForm(r) {
      this.form.id = r.id || 0;
      this.form.name = r.name || '';
      this.form.client_id = Number(r.user_id ?? r.client_id ?? r.user?.id ?? 0) || 0;
      this.form.document_type = r.document_type || '';
      this.form.document = r.document || '';
      this.form.address = r.address || '';
      this.form.phone = r.phone || '';
      this.form.email = r.email || '';
      this.form.type = r.type || 'production';
      this.form.observation = r.observation || '';
      this.form.status =
        typeof r.status === 'string' ? parseInt(r.status, 10) || 0 : r.status ?? 0;
      this.form.payment_method = r.payment_method || '';
      this.form.discount_amount = parseFloat(r.discount_amount) || 0;
      this.form.flete = parseFloat(r.flete) || 0;
      this.form.gift_value = parseFloat(r.gift_value) || 0;
      this.form.amount_paid = parseFloat(r.amount_paid) || 0;
      this.form.subtotal = parseFloat(r.subtotal) || 0;
      this.form.grand_total = parseFloat(r.grand_total) || 0;
      this.modal.remission_id = r.id || 0;
    },
    openClientModal() {
      // Resetear el formulario del nuevo cliente
      this.newClient = {
        id: 0,
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        role: '4',
        status: '1',
        password: 'cliente123',
        password_confirmation: 'cliente123',
        payment: '0',
        processes: [],
      };
      
      const modalElement = document.getElementById('ModalClient');
      this.clientModal = new Modal(modalElement);
      this.clientModal.show();
    },
    closeClientModal() {
      if (this.clientModal) {
        this.clientModal.hide();
      }
    },
    async saveClient() {
      try {
        // Validar campos requeridos
        if (!this.newClient.name || !this.newClient.email || !this.newClient.phone) {
          await Swal.fire({
            icon: 'warning',
            title: 'Campos requeridos',
            text: 'Por favor complete todos los campos obligatorios.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
        
        // Crear el cliente en usuarios
        const response = await this.$store.dispatch('users/save', this.newClient);
        
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El cliente ha sido registrado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          
          await this.getClients({ forceRebuild: true });

          this.$nextTick(() => {
            if (response.data.id) {
              this.refreshClientSelect2Value(response.data.id);
            }
          });
          
          this.closeClientModal();
        } else {
          throw new Error(response.data?.message || 'Error al guardar el cliente');
        }
      } catch (error) {
        console.error("Error al crear el cliente:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar el cliente',
        });
      }
    },
    async getModels() {
      this.loadingProducts = true;
      try {
        const res = await posService.getProducts({ page: 1, per_page: 1000 });
        const d = res.data;
        this.models = { data: d.data || [] };
      } catch (error) {
        console.error('Error al cargar productos:', error);
      } finally {
        this.loadingProducts = false;
      }
    },
    onProductClick(prod) {
      if (prod.has_variants && prod.variants && prod.variants.length > 0) {
        // Cerrar el modal de productos primero, luego mostrar el de variantes
        if (this.modalBudget) {
          this.modalBudget.hide();
        }
        this.$nextTick(() => {
          this.pendingProduct = prod;
          this.selectedVariantId = null;
          this.showVariantModal = true;
        });
      } else {
        this.addDirectToDetail(prod, null);
      }
    },
    cancelVariantModal() {
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;
    },
    confirmVariant() {
      if (!this.selectedVariantId || !this.pendingProduct) return;
      const variant = this.pendingProduct.variants.find((v) => v.id === this.selectedVariantId);
      if (!variant) return;
      const prod = this.pendingProduct;
      this.cancelVariantModal();
      this.addDirectToDetail(prod, variant);
    },
    async addDirectToDetail(prod, variant) {
      const payload = {
        id: 0,
        remission_id: this.form.id,
        inventory_id: prod.id,
        variant_id: variant ? variant.id : null,
        quantity: 1,
        price: variant ? parseFloat(variant.price || 0) : parseFloat(prod.sale_price || 0),
        iva: 0,
      };

      try {
        const response = await this.$store.dispatch('remissionsDetails/save', payload);
        if (response && response.status >= 200 && response.status < 300) {
          this.productSearch = '';
          this.getData();
          this.closeModal();
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response?.data?.message || 'No se pudo agregar el producto.',
          });
        }
      } catch (error) {
        console.error('Error al agregar producto:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo agregar el producto.',
        });
      }
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.remission_id = this.form.id;
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.inventory_id = 0;
      this.modal.variant_id = null;
      this.modal.quantity = 0;
      this.modal.price = 0;
      this.modal.iva = 0;
      this.modal.total = 0;
      this.productSearch = '';
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;

      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de agregar productos.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.getModels();
      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      this.showVariantModal = false;
      this.pendingProduct = null;
      this.selectedVariantId = null;
      this.productSearch = '';
      if (this.modalBudget) {
        this.modalBudget.hide();
      }
    },
    async getData() {
      this.data = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
      // Recalcular subtotal y grand_total desde los detalles
      if (this.data?.data) {
        const subtotal = this.data.data.reduce((s, d) => s + parseFloat(d.total || 0), 0);
        this.form.subtotal = subtotal;
        this.form.grand_total = subtotal - parseFloat(this.form.discount_amount || 0)
          + parseFloat(this.form.flete || 0) + parseFloat(this.form.gift_value || 0);
      }
    },
    async confirm() {
      // Verificar que la remisión tenga un ID
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe guardar la remisión primero antes de formalizarla.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'info',
        title: 'Formalizar remisión',
        text: 'Al formalizar la remisión se restará la cantidad del stock disponible en los productos de producción. Ya no se podrá editar los registros ni los detalles de la remisión.',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        backdrop: true,
      });

      if (result.isConfirmed) {
        try {
          const response = await this.$store.dispatch("remissions/formalize", this.form.id);
          
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'La remisión ha sido formalizada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            }).then(() => {
              // Actualizar el estado del formulario
              this.form.status = 1;
              // Recargar los datos para reflejar los cambios
              this.getData();
            });
          } else {
            throw new Error(response.data?.message || 'Error al formalizar la remisión');
          }
        } catch (error) {
          console.error("Error al formalizar la remisión:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || error.message || 'Error al formalizar la remisión',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    },
    async devolucion() {
      if (!this.form.id || this.form.id === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'No hay una remisión válida para devolver.',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      const result = await Swal.fire({
        icon: 'warning',
        title: 'Devolución de remisión',
        text: 'Al marcar como devolución, el stock de los productos se sumará de vuelta al inventario. Esta acción no se puede deshacer.',
        showCancelButton: true,
        confirmButtonText: 'Sí, devolver',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        backdrop: true,
      });

      if (!result.isConfirmed) return;

      try {
        this.form.type = 'return';
        const response = await this.$store.dispatch("remissions/save", this.form);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Devolución exitosa!',
            text: 'La remisión ha sido marcada como devolución y el stock ha sido restaurado.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.form.type = 'return';
            this.getData();
          });
        } else {
          throw new Error(response.data?.message || 'Error al procesar la devolución');
        }
      } catch (error) {
        console.error("Error al procesar devolución:", error);
        this.form.type = 'production';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al procesar la devolución',
          confirmButtonText: 'Aceptar'
        });
      }
    },
    async save() {
      try {
        if (this.$refs.clientSelect) {
          const selected = $(this.$refs.clientSelect).val();
          if (selected) {
            this.form.client_id = Number(selected) || 0;
          }
        }

        // Si hay datos de contacto pero aún no hay cliente (user_id), intentar emparejar o crear usuario
        if (this.form.name && this.form.client_id == 0) {
          // Verificar si el cliente ya existe por email o nombre
          const existingClient = this.clients.find(c => 
            c.email === this.form.email || c.name === this.form.name
          );
          
          if (!existingClient && this.form.email && this.form.name) {
            // Crear el cliente en usuarios
            const clientData = {
              id: 0,
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone || '',
              address: this.form.address || '',
              document_type: this.form.document_type || 'CC',
              document: this.form.document || '',
              role: '4', // Cliente
              status: '1',
              password: 'cliente123',
              password_confirmation: 'cliente123',
              payment: '0',
              processes: [],
            };
            
            const clientResponse = await this.$store.dispatch('users/save', clientData);
            
            if (clientResponse && clientResponse.status >= 200 && clientResponse.status < 300) {
              this.form.client_id = clientResponse.data.id;
              // Recargar la lista de clientes
              await this.getClients({ forceRebuild: true });
            }
          } else if (existingClient) {
            this.form.client_id = existingClient.id;
          }
        }

        if (!Number(this.form.client_id)) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cliente requerido',
            text: 'Seleccione un cliente en el campo Cliente antes de guardar.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Dispara la acción de Vuex para guardar la remisión
        const response = await this.$store.dispatch("remissions/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = response.data;
              this.form.id = response.data.id || 0;
              this.form.client_id = Number(response.data.user_id ?? response.data.client_id ?? 0) || 0;
              
              // Actualizar el remission_id en el modal si está abierto
              if (this.modal.remission_id === 0) {
                this.modal.remission_id = this.form.id;
              }
              
              // Si se formalizó, recargar los datos
              if (this.form.status === 1) {
                this.getData();
              }

              this.$nextTick(() => {
                if (Number(this.form.client_id) > 0) {
                  this.refreshClientSelect2Value(this.form.client_id);
                }
              });

            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitForm() {
      try {
        if (!this.modal.inventory_id) {
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Seleccione un producto.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        const selectedProduct = this.models.data.find(prod => prod.id == this.modal.inventory_id);

        if (selectedProduct && selectedProduct.manage_stock && this.modal.quantity > (selectedProduct.quantity || 0)) {
          Swal.fire({
            icon: 'warning',
            title: 'Cantidad excedida',
            text: 'La cantidad ingresada supera el stock disponible.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        // Dispara la acción de Vuex para guardar el modal
        const response = await this.$store.dispatch("remissionsDetails/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.inventory_id = 0;
              this.modal.variant_id = null;
              this.modal.quantity = 0;
              this.modal.price = 0;
              this.modal.iva = 0;
              this.modal.total = 0;
              this.productSearch = '';

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async onDetailQuantityChange(event, value) {
      const input = event.target;
      const newQty = parseInt(input.value, 10);
      const currentQty = parseInt(value.quantity, 10);
      if (isNaN(newQty) || newQty < 1) {
        input.value = currentQty;
        return;
      }
      if (newQty === currentQty) return;

      const detailId = value.id;
      const remissionId = value.remission_id;
      const price = parseFloat(value.price) || 0;
      const iva = parseFloat(value.iva) || 0;

      let response;
      try {
        response = await this.$store.dispatch('remissionsDetails/save', {
          id: detailId,
          remission_id: remissionId,
          quantity: newQty,
          price,
          iva,
        });
      } catch (error) {
        console.error('Error al actualizar cantidad del detalle:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar la cantidad.',
        });
        input.value = currentQty;
        return;
      }

      if (response && response.status >= 200 && response.status < 300) {
        this.getData();
      } else {
        input.value = currentQty;
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response?.data?.message || 'No se pudo actualizar la cantidad.',
        });
      }
    },
    async editRegister() {
      // La edición de cantidad se hace directamente desde la tabla con onDetailQuantityChange
      // Este método se mantiene por compatibilidad pero no abre el modal
      Swal.fire({
        icon: 'info',
        title: 'Editar detalle',
        text: 'Puede editar la cantidad directamente en la tabla de detalles.',
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async printRemission(id) {
      try {
        const response = await this.$store.dispatch("remissions/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Remision_${id}.pdf`); // Nombre del archivo
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF de la remisión',
        });
      }
    },

    formatCOP(value) {
      return parseFloat(value || 0).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    async loadPayments() {
      if (!this.form.id) return;
      try {
        const res = await remissionPaymentsService.getByRemission(this.form.id);
        this.payments = res.data || [];
      } catch (e) {
        console.error('Error cargando pagos', e);
      }
    },

    openPaymentModal() {
      this.paymentForm = {
        payment_method: 'EFECTIVO',
        amount: 0,
        reference: '',
        notes: '',
        payment_date: new Date().toISOString().slice(0, 10),
      };
      if (!this.paymentModal) {
        this.paymentModal = new Modal(document.getElementById('ModalPayment'));
      }
      this.paymentModal.show();
    },

    closePaymentModal() {
      this.paymentModal?.hide();
    },

    async savePayment() {
      if (!this.paymentForm.amount || this.paymentForm.amount <= 0) {
        Swal.fire('Error', 'El valor debe ser mayor a 0.', 'error');
        return;
      }
      this.savingPayment = true;
      try {
        await remissionPaymentsService.store({
          remission_id:   this.form.id,
          payment_method: this.paymentForm.payment_method,
          amount:         this.paymentForm.amount,
          reference:      this.paymentForm.reference || null,
          notes:          this.paymentForm.notes || null,
          payment_date:   this.paymentForm.payment_date || null,
        });
        this.closePaymentModal();
        await this.loadPayments();
      } catch (e) {
        Swal.fire('Error', e?.response?.data?.message || 'No se pudo guardar el pago.', 'error');
      } finally {
        this.savingPayment = false;
      }
    },

    async deletePayment(id) {
      const result = await Swal.fire({
        title: '¿Eliminar pago?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      try {
        await remissionPaymentsService.destroy(id);
        await this.loadPayments();
      } catch (e) {
        Swal.fire('Error', e?.response?.data?.message || 'No se pudo eliminar el pago.', 'error');
      }
    },

    async getDocumentos() {
      if (!this.form.id || this.form.id === 0) return;
      try {
        const media = await this.$store.dispatch('media/getData', this.form.id);
        this.documentos = media.data.filter(item => item.mediaable_type === 'remission');
      } catch (error) {
        console.error("Error al obtener evidencias:", error);
        this.documentos = [];
      }
    },

    async saveEvidencia() {
      const fileInput = document.getElementById("fileEvidenciaRemission");
      if (!fileInput) return;

      try {
        const file = fileInput.files[0];
        if (!file) return;

        const fileExtension = file.name.split('.').pop().toLowerCase();
        const validExtensions = ['jpeg', 'jpg', 'png', 'gif', 'svg', 'pdf'];
        if (!validExtensions.includes(fileExtension)) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Solo se permiten archivos de imagen (JPEG, PNG, JPG, GIF, SVG) o PDF.',
          });
          this.$nextTick(() => { if (fileInput) fileInput.value = ''; });
          return;
        }

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'remission');
        formData.append("file", file);

        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'La evidencia ha sido guardada correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });
          this.getDocumentos();
          this.$nextTick(() => { if (fileInput) fileInput.value = ''; });
        } else {
          throw new Error(response.data?.message || 'Error al guardar la evidencia');
        }
      } catch (error) {
        console.error("Error al guardar evidencia:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al guardar la evidencia',
        });
        this.$nextTick(() => {
          const input = document.getElementById("fileEvidenciaRemission");
          if (input) input.value = '';
        });
      }
    },

    async deleteMedia(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar!',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      try {
        await this.$store.dispatch("media/delete", id);
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'La evidencia ha sido eliminada correctamente.',
          confirmButtonText: 'Aceptar',
        });
        this.getDocumentos();
      } catch (error) {
        console.error("Error al eliminar evidencia:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al eliminar la evidencia',
        });
      }
    },

    viewDocument(filePath) {
      const fileExtension = filePath.split('.').pop().toLowerCase();
      if (fileExtension === 'pdf') {
        window.open(this.apiUrl + filePath, '_blank');
      } else {
        const imageHtml = `<img src="${this.apiUrl + filePath}" alt="Evidencia" style="width: 100%; height: auto;" />`;
        Swal.fire({
          html: imageHtml,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Cerrar',
          backdrop: false,
        });
      }
    },

    isImage(filePath) {
      if (!filePath) return false;
      const ext = filePath.split('.').pop().toLowerCase();
      return ['jpeg', 'jpg', 'png', 'gif', 'svg'].includes(ext);
    },

    getFileIcon(filePath) {
      if (!filePath) return 'fa fa-file';
      const ext = filePath.split('.').pop().toLowerCase();
      if (ext === 'pdf') return 'fa fa-file-pdf text-danger';
      return 'fa fa-file-image text-primary';
    },
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
    const route = useRoute();
    const dataEdit = route.params.data;

    let parsedEdit = null;
    /** Incluir el `user_id` de la remisión **antes** de crear Select2 (rol ≠ clientes, usuarios cargados después, etc.). */
    const seedClients = [];

    if (dataEdit) {
      try {
        parsedEdit = JSON.parse(dataEdit);
      } catch (error) {
        console.error('Error al parsear remisión (params.data):', error);
      }
    }

    /*
     * Recomponer objeto como en servidor: las filas del listado pueden no traer bien `user_id`.
     */
    if (parsedEdit?.id) {
      try {
        const res = await this.$store.dispatch(
          'remissions/getData',
          parsedEdit.id,
        );
        const apiRow = res?.data;
        if (apiRow && typeof apiRow === 'object') {
          parsedEdit = { ...parsedEdit, ...apiRow };
        }
      } catch (error) {
        console.warn(
          'No se pudo refrescar la remisión por API para select de cliente:',
          error,
        );
      }
    }

    if (parsedEdit?.id) {
      const uid =
        Number(
          parsedEdit.user_id ??
            parsedEdit.client_id ??
            parsedEdit.user?.id ??
            0,
        ) || 0;
      if (uid) {
        if (parsedEdit.user && parsedEdit.user.id != null) {
          seedClients.push(parsedEdit.user);
        } else {
          seedClients.push({
            id: uid,
            name: parsedEdit.name,
            email: parsedEdit.email,
            phone: parsedEdit.phone,
            address: parsedEdit.address,
            document: parsedEdit.document,
            document_type: parsedEdit.document_type,
            role: parsedEdit.role ?? '4',
          });
        }
      }
    }

    await new Promise((resolve) => this.$nextTick(resolve));
    await this.getClients({ forceRebuild: true, seedClients });

    if (parsedEdit && parsedEdit.id) {
      this.data = parsedEdit;
      this.applyRemissionToForm(parsedEdit);
      this.inferClientIdFromRemissionRow(parsedEdit);

      await this.$nextTick();
      await this.$nextTick();

      if (Number(this.form.client_id) > 0) {
        this.refreshClientSelect2Value(this.form.client_id);
      }

      await this.getData();
      await this.loadPayments();
      await this.getDocumentos();
      this.getModels();

      this.$nextTick(() => {
        if (Number(this.form.client_id) > 0) {
          this.refreshClientSelect2Value(this.form.client_id);
        }
      });
    }
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.rem-product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
  max-height: 380px;
  overflow-y: auto;
  padding: 4px;
}

.rem-product-card {
  display: block;
  width: 100%;
  text-align: left;
  background: #fff;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.rem-product-card:hover {
  border-color: #82d616;
  background: #f8fff4;
}

.rem-product-card--selected {
  border-color: #82d616;
  background: #eafbe2;
  box-shadow: 0 0 0 1px #82d616;
}

.rem-product-info h6 {
  font-weight: 600;
}

/* ---- Modal variantes (estilo POS) ---- */
.rem-variant-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rem-variant-box { width: 100%; max-width: 420px; border-radius: 12px; }
.rem-variant-list {
  display: flex;
  flex-direction: column;
  gap: .4rem;
  max-height: 340px;
  overflow-y: auto;
}
.rem-variant-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5rem;
  padding: .55rem .75rem;
  border: 1.5px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color .15s, background .15s;
}
.rem-variant-btn:hover { border-color: #82d616; background: #f6fff0; }
.rem-variant-btn--selected { border-color: #82d616 !important; background: #f0ffe0 !important; }
.rem-variant-title { font-size: 13px; font-weight: 600; flex: 1; }
.rem-variant-meta  { font-size: 12px; white-space: nowrap; }

/* Miniaturas de evidencias */
.evidence-thumbnails {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.evidence-thumb-wrapper {
  position: relative;
  width: 100px;
}
.evidence-thumb {
  width: 100px;
  height: 100px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  transition: transform 0.15s, box-shadow 0.15s;
}
.evidence-thumb:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.evidence-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.evidence-thumb-file {
  flex-direction: column;
  gap: 4px;
  padding: 8px;
}
.evidence-thumb-name {
  font-size: 9px;
  text-align: center;
  word-break: break-word;
  line-height: 1.2;
  color: #67748e;
}
.evidence-thumb-delete {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: #e53e3e;
  color: #fff;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}
.evidence-thumb-delete:hover {
  background: #c53030;
}
.evidence-thumb-info {
  text-align: center;
  margin-top: 4px;
}
.evidence-thumb-method {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #67748e;
  text-transform: uppercase;
}
.evidence-thumb-amount {
  display: block;
  font-size: 10px;
  color: #2d3748;
}
</style>
